import { defineStore } from 'pinia';
import OrderService from 'src/core/services/OrderService';

export const OrderCancelRefundStore = defineStore('OrderCancelRefundStore', {
  state: () => ({
    cancelRefundList: {
      list: [],
      count: 0,
    },
  }),
  actions: {
    async userCancelAndRefundList(listInfo) {
      const { status, message, data } = await OrderService.userCancelAndRefundList(listInfo);
      if (status._200_) {
        this.cancelRefundList.list = data.list;
      }

      return { status, message, data };
    },
  },
});
